// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2Mric","header":"ClearentDisclaimer_header__3uQqT","inner":"ClearentDisclaimer_inner__13eRY"};